<template>
  <div class="">
    <p v-if="label">{{label}}</p>
    <div class="input-group">
      <div class="input-group-prepend">
        <span class="input-group-text">
            <i class="icons8-search"></i>
        </span>
      </div>
      <input type="search" class="form-control" placeholder="Search..." @input="$emit('input',searchInput)" v-model="searchInput">
    </div>
  </div>
</template>
<script>
  export default {
    props:["label","value"],
    data(){
      return {
        searchInput:this.value
      }
    }
  }
</script>
